














import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';
import BookingRoleWorkerShiftStatus from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';


@Component({
  name: 'BookingRoleWorkerStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	bookingRoleWorker: BookingRoleWorkerDto;
	@Prop({required: true})
	shiftCount: number;

	get shortlisted() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.Shortlisted);
	}

	get offered() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.Offered);
	}

	get rejected() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.Rejected);
	}

	get declined() {
		const declined: boolean = this.hasStatus(BookingRoleWorkerShiftStatus.DeclinedOffer);
		if (declined) {
			return true;
		}
		return this.hasStatus(BookingRoleWorkerShiftStatus.DeclinedBooking);
	}

	get applied() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.Applied);
	}

	get bookedUnconfirmed() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.BookedUnconfirmed);
	}

	get bookedConfirmed() {
		if (!this.hasStatus(BookingRoleWorkerShiftStatus.BookedUnconfirmed) && this.fullyBooked) {
			return false //we show the fully booked pill
		}
		return this.hasStatus(BookingRoleWorkerShiftStatus.BookedConfirmed)
	}

	get cancelled() {
		return this.hasStatus(BookingRoleWorkerShiftStatus.Cancelled);
	}

	get fullyBooked() {
		let bookedCount = 0;
		for (let index = 0; index < this.bookingRoleWorker.bookingRoleWorkerShifts.length; index++) {
			if (this.bookingRoleWorker.bookingRoleWorkerShifts[index].status === BookingRoleWorkerShiftStatus.BookedUnconfirmed
			|| this.bookingRoleWorker.bookingRoleWorkerShifts[index].status === BookingRoleWorkerShiftStatus.BookedConfirmed) {
				bookedCount ++;
			}
		}
		return bookedCount === this.shiftCount;
	}

	hasStatus(status: BookingRoleWorkerShiftStatus) {
		for (let index = 0; index < this.bookingRoleWorker.bookingRoleWorkerShifts.length; index++) {
			if (this.bookingRoleWorker.bookingRoleWorkerShifts[index].status === status) {
				return true
			}
		}
		return false;
	}
}
